import React from "react";
import "./Footer.css";

/* ── Inline SVG icons – no icon library needed ── */

const IconWhatsApp = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const IconMail = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="4" width="20" height="16" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);

const IconPhone = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.69h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.1a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

const IconMapPin = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const IconTag = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2H2v10l9.29 9.29a1 1 0 0 0 1.42 0l8.3-8.3a1 1 0 0 0 0-1.42Z"/>
    <path d="M7 7h.01"/>
  </svg>
);

const IconAtSign = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="4"/>
    <path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"/>
  </svg>
);

const IconPhoneSmall = () => (
  <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13.5a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2.69h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 10.1a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);

/* Small clock/link icon used in lists (matches original ⏱ style) */
const IconLink = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.55, flexShrink: 0 }}>
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
);

/* Social icons */
const IconFacebook = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="white">
    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
  </svg>
);

const IconX = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="white">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
  </svg>
);

const IconInstagram = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="white">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
    <path fill="url(#ig-inner)" d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    <defs>
      <radialGradient id="ig-inner" cx="30%" cy="107%" r="150%">
        <stop offset="0%" stopColor="#fdf497"/>
        <stop offset="45%" stopColor="#fd5949"/>
        <stop offset="60%" stopColor="#d6249f"/>
        <stop offset="90%" stopColor="#285AEB"/>
      </radialGradient>
    </defs>
  </svg>
);

const IconYouTube = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="white">
    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46a2.78 2.78 0 0 0-1.95 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.41 19.54C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.95A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
    <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="#ff0000"/>
  </svg>
);

const IconLinkedIn = () => (
  <svg viewBox="0 0 24 24" width="17" height="17" fill="white">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
    <rect x="2" y="9" width="4" height="12"/>
    <circle cx="4" cy="4" r="2"/>
  </svg>
);

/* Document / Policy icon */
const IconDoc = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.55, flexShrink: 0 }}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
  </svg>
);

const IconTruck = () => (
  <svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.55, flexShrink: 0 }}>
    <rect x="1" y="3" width="15" height="13"/>
    <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/>
    <circle cx="5.5" cy="18.5" r="2.5"/>
    <circle cx="18.5" cy="18.5" r="2.5"/>
  </svg>
);

function Footer({
  ctaHeading = "Have Questions About Our\nTraining Programs?",
  ctaSub = "Feel free to reach out to us for any queries or guidance.\nOur team is here to help you choose the right path."
}) {
  return (
    <div className="ft__root">

      {/* CTA Section */}
      <div className="ft__cta">
        <div className="ft__cta-inner">
          <div className="ft__cta-badge">
            <span className="ft__cta-dot"></span>
            WE'RE HERE TO HELP
          </div>
          <h2 className="ft__cta-heading">
  {ctaHeading.split('\n').map((line, i) => (
    <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
  ))}
</h2>
<p className="ft__cta-sub">
  {ctaSub.split('\n').map((line, i) => (
    <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
  ))}
</p>
          <div className="ft__cta-btns">
            <a href="https://wa.me/919442717713" target="_blank" rel="noreferrer" className="ft__btn ft__btn--green">
              <IconWhatsApp /> +91 94427 17713
            </a>
            <a href="mailto:info@ibots.in" className="ft__btn ft__btn--outline">
              <IconMail /> info@ibots.in
            </a>
            
          </div>
        </div>
      </div>

      {/* Main Footer Links */}
      <div className="ft__main">
        <div className="ft__cols">

          <div className="ft__col">
            <h4 className="ft__col-heading">CONSUMER POLICY</h4>
            <div className="ft__col-divider"></div>
            <ul className="ft__links">
              <li><a href="/terms" className="ft__link"><IconDoc /> Terms and Conditions</a></li>
              <li><a href="/shipping" className="ft__link"><IconTruck /> Shipping Policy</a></li>
            </ul>
          </div>

          <div className="ft__col">
            <h4 className="ft__col-heading">WORK WITH US</h4>
            <div className="ft__col-divider"></div>
            <ul className="ft__links">
              <li><a href="/internship" className="ft__link"><IconLink /> Internship Program</a></li>
              <li><a href="/affiliate" className="ft__link"><IconLink /> Affiliate Program</a></li>
              <li><a href="/investor" className="ft__link"><IconLink /> Investor</a></li>
              <li><a href="/franchise" className="ft__link"><IconLink /> Franchise</a></li>
              <li><a href="/knowledge-partner" className="ft__link"><IconLink /> Knowledge Partner</a></li>
            </ul>
          </div>

          <div className="ft__col">
            <h4 className="ft__col-heading">COMPANY</h4>
            <div className="ft__col-divider"></div>
            <ul className="ft__links">
              <li><a href="/about" className="ft__link"><IconLink /> About Us</a></li>
              <li><a href="/blogs" className="ft__link"><IconLink /> Blogs</a></li>
              <li><a href="/careers" className="ft__link"><IconLink /> Careers</a></li>
              <li><a href="/newsletter" className="ft__link"><IconLink /> Newsletter</a></li>
              <li><a href="/project-development" className="ft__link"><IconLink /> Project Development</a></li>
            </ul>
          </div>

          <div className="ft__col">
            <h4 className="ft__col-heading">CONTACT US</h4>
            <div className="ft__col-divider"></div>
            <div className="ft__contact-block">
              <div className="ft__contact-row">
                <span className="ft__contact-icon"><IconMapPin /></span>
                <span>ibots Academy, 34/17A, First floor, Ramalingam Nagar 4th Cross street, Saibaba colony, Coimbatore – 641 011, Tamil Nadu, India.</span>
              </div>
              <div className="ft__contact-row">
                <span className="ft__contact-icon"><IconTag /></span>
                <span>GST: 33AAMCP9459K1ZO</span>
              </div>
              <div className="ft__contact-row">
                <span className="ft__contact-icon"><IconAtSign /></span>
                <a href="mailto:info@ibots.in" className="ft__contact-link">info@ibots.in</a>
              </div>
              <div className="ft__contact-row">
                <span className="ft__contact-icon"><IconPhoneSmall /></span>
                <a href="tel:+919442717713" className="ft__contact-link">+91 9442717713</a>
              </div>
            </div>

            <div className="ft__follow">
              <h5 className="ft__follow-heading">FOLLOW US</h5>
              <div className="ft__socials">
                <a
                  href="https://www.facebook.com/Technologyhardwares/"
                  target="_blank" rel="noreferrer"
                  className="ft__social-btn"
                  style={{ backgroundColor: "#1877f2" }}
                  aria-label="Facebook"
                >
                  <IconFacebook />
                </a>
                <a
                  href="https://twitter.com/IniBots"
                  target="_blank" rel="noreferrer"
                  className="ft__social-btn"
                  style={{ backgroundColor: "#000000" }}
                  aria-label="X (Twitter)"
                >
                  <IconX />
                </a>
                <a
                  href="https://www.instagram.com/ibots.in/"
                  target="_blank" rel="noreferrer"
                  className="ft__social-btn"
                  style={{ background: "radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%)" }}
                  aria-label="Instagram"
                >
                  <IconInstagram />
                </a>
                <a
                  href="https://www.youtube.com/@iBotsin"
                  target="_blank" rel="noreferrer"
                  className="ft__social-btn"
                  style={{ backgroundColor: "#ff0000" }}
                  aria-label="YouTube"
                >
                  <IconYouTube />
                </a>
                <a
                  href="https://www.linkedin.com/company/ibots-in/"
                  target="_blank" rel="noreferrer"
                  className="ft__social-btn"
                  style={{ backgroundColor: "#0077b5" }}
                  aria-label="LinkedIn"
                >
                  <IconLinkedIn />
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Approved & Associated With */}
      <div className="ft__approved">
        <p className="ft__approved-label">APPROVED &amp; ASSOCIATED WITH</p>
        <div className="ft__logos-row">
          <div className="ft__logo-box">
            <img
              src="https://ibots.in/wp-content/uploads/2026/02/DPIIT-4.png"
              alt="Government of India – DPIIT"
              style={{ height: "48px", width: "auto", objectFit: "contain" }}
            />
          </div>
          <div className="ft__logo-box">
            <img
              src="https://ibots.in/wp-content/uploads/2026/02/DPIIT-2.png"
              alt="Startup India"
              style={{ height: "48px", width: "auto", objectFit: "contain" }}
            />
          </div>
          <div className="ft__logo-box">
            <img
              src="https://ibots.in/wp-content/uploads/2026/02/StartupTN-1.png"
              alt="StartupTN"
              style={{ height: "48px", width: "auto", objectFit: "contain" }}
            />
          </div>
          <div className="ft__logo-box">
            <img
              src="https://ibots.in/wp-content/uploads/2026/02/Raspberry-Pi-1.png"
              alt="Raspberry Pi"
              style={{ height: "48px", width: "auto", objectFit: "contain" }}
            />
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="ft__bottom">
        <span className="ft__copyright">© 2026. Protowiz Private Limited &amp; IBOTS.IN. All rights reserved.</span>
        <div className="ft__payments">
          <span className="ft__payment-label">Secure Payments:</span>
          <img
            src="https://ibots.in/wp-content/themes/woodmart/images/payments.png"
            alt="Secure Payments – VISA, Mastercard, PayPal, AMEX"
            style={{ height: "24px", width: "auto", objectFit: "contain" }}
          />
        </div>
      </div>

    </div>
  );
}

export default Footer;
